// extracted by mini-css-extract-plugin
export var sponsorAds = "sponsorAds-module--sponsorAds--PWJaL";
export var sponsorAds__adMark = "sponsorAds-module--sponsorAds__adMark--roe+f";
export var sponsorAds__desktop = "sponsorAds-module--sponsorAds__desktop--05Ezk";
export var sponsorAds__mobile = "sponsorAds-module--sponsorAds__mobile--kXPPb";